// Тосты-подсказки для новичков, которые игрок может отключить ссылкой «Не
// показывать эту подсказку» в самом тосте (Toast.js). Именно localStorage,
// как и прочие разовые знакомства (см. ratingCrystalsIntroStorage): отказ от
// подсказки — выбор на этом устройстве
export const TOAST_HINTS = {
  // Выбор типа отряда на этапе найма: просьба выбрать подсвеченную казарму
  RECRUITMENT_SELECT_BARRACKS: 'recruitmentSelectBarracks',
  // Выбор типа отряда на этапе найма, когда своей свободной казармы нет
  RECRUITMENT_NO_FREE_BARRACKS: 'recruitmentNoFreeBarracks',
};

export const getToastHintHiddenStorageKey = (hintId) => `toastHintHidden_${hintId}`;

/**
 * Отключил ли игрок подсказку. Недоступный localStorage (Safari в приватном
 * режиме) — подсказку показываем: новичку лишний раз не помешает
 */
export const checkIfToastHintHidden = (hintId) => {
  try {
    return window.localStorage.getItem(getToastHintHiddenStorageKey(hintId)) === '1';
  } catch (e) {
    return false;
  }
};

/** Отключить подсказку — по ссылке в тосте */
export const rememberToastHintHidden = (hintId) => {
  try {
    window.localStorage.setItem(getToastHintHiddenStorageKey(hintId), '1');
  } catch (e) {
    // Работаем без localStorage: подсказка покажется и в следующий раз
  }
};
